'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var aspectRatio = function () {
  function aspectRatio(ratioWidth, ratioHeight) {
    _classCallCheck(this, aspectRatio);
    if (!ratioWidth || !ratioHeight) {
      throw new Error("Missing ratio with or ratio height");
    } else if (typeof ratioWidth !== 'number' || typeof ratioHeight !== 'number') {
      throw new Error('ratio with and ratio height must be a numbers');
    }
    this._ratioWidth = ratioWidth;
    this._ratioHeight = ratioHeight;
    this._relation = this._ratioWidth / this._ratioHeight;
  }
  _createClass(aspectRatio, [{
    key: 'getFullWidth',
    value: function getFullWidth() {
      if (!window) {
        throw new Error('get full width only works in browser environment');
      }
      return /iphone|android/gi.test(navigator.userAgent) ? Math.round(window.innerHeight / this._relation) : Math.round(window.innerHeight * this._relation);
    }
  }, {
    key: 'getFullHeight',
    value: function getFullHeight() {
      if (!window) {
        throw new Error('get full height only works in browser environment');
      }
      return Math.round(window.innerHeight);
    }
  }, {
    key: 'getWidth',
    value: function getWidth(pixelsHeight) {
      if (!pixelsHeight) {
        throw new Error("Missing pixels height");
      } else if (typeof pixelsHeight !== 'number') {
        throw new Error('pixels height must be a number');
      }
      return Math.round(pixelsHeight * this._relation);
    }
  }, {
    key: 'getHeight',
    value: function getHeight(pixelsWidth) {
      if (!pixelsWidth) {
        throw new Error("Missing pixels height");
      } else if (typeof pixelsWidth !== 'number') {
        throw new Error('pixels height must be a number');
      }
      return Math.round(pixelsWidth / this._relation);
    }
  }]);
  return aspectRatio;
}();
exports.default = aspectRatio;